<template>
  <div class="transaction-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title text-capitalize">Configurações &raquo; {{ termPlural }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <validation-observer ref="transactionForm" v-slot="{ invalid }">
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Informações d{{ letter }} {{ termSingular }}</p>
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col cols="12" md="6">
                      <label class="cj-label">Nome</label>
                      <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="directingSectorForm.name" :disabled="!((directingSectorForm.id == null && canAdd) || (directingSectorForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col cols="12">
                      <label class="cj-label">Observações</label>
                      <b-form-textarea v-model="directingSectorForm.notes" rows="2" max-rows="5" no-resize maxlength="500" :disabled="!((directingSectorForm.id == null && canAdd) || (directingSectorForm.id != null && canEdit))"></b-form-textarea>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col cols="12"><hr></b-col>
                    <b-col>
                      <label class="cj-label">Profissionais que podem acessar este setor</label>
                      <validation-provider name="profissionais" :rules="{ required: false }" v-slot="{ errors }">
                        <multiselect v-model="directingSectorForm.professionals" :options="professionals" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" :multiple="true" :disabled="!((directingSectorForm.id == null && canAdd) || (directingSectorForm.id != null && canEdit))" placeholder="Profissionais que podem acessar este setor" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="((directingSectorForm.id == null && canAdd) || (directingSectorForm.id != null && canEdit) || canRemove)">
                  <b-button variant="primary" class="mr-3" :disabled="!canPerformAction || !((directingSectorForm.id == null && canAdd) || (directingSectorForm.id != null && canEdit))" @click="saveDirectingSector">Salvar</b-button>
                  <b-button variant="danger" v-if="directingSectorForm.id != null && canRemove" @click="deleteDirectingSector">Excluir</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-container>

  </div>
</template>

<script>

  export default {
    data() {
      return {
        leavingPage: false,
        user: null,

        termSingular: 'setor',
        termPlural: 'setores',
        url: 'configuracoes/setores',
        letter: 'o',
        newTerm: 'cadastrar-setor',
        module: 'directing-sectors',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        directingSectorForm: {
          id: null,
          name: null,
          notes: null,
          professionals: [],
        },

        professionals: []
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.canSee = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_manage');

      if(this.canSee == false || !this.user.person.client.directing_enabled) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      await this.api.getPeople({type: 'PROFESSIONAL', all: true}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.professionals = [];
        res.data.forEach(professional => {
          this.professionals.push({value: professional.id, name: professional.name});
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Professional', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar os profissionais da sua clínica! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Professional', err.response);
      });

      if(this.$route.params.id != this.newTerm) {
        await this.api.getDirectingSector(this.$route.params.id).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          let directingSectorData = res.data;

          this.directingSectorForm = {
            id: directingSectorData.id,
            name: directingSectorData.name,
            notes: directingSectorData.notes,
            professionals: [],
          };

          directingSectorData.professionals.forEach(professional => {
            this.directingSectorForm.professionals.push({value: professional.id, name: professional.name});
          });

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Directing Area', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$router.push({path: '/' + this.url}).catch(() => {});

          this.$swal('Ops...', 'Não conseguimos carregar esta ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Directing Area', err.response);
        });
      } else {
        this.canPerformAction = true;
      }
      this.eventBus.$emit('IS_LOADING', false);
    },
    methods: {
      async saveDirectingSector() {
        if(!this.canPerformAction || !((this.directingSectorForm.id == null && this.canAdd) || (this.directingSectorForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.transactionForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let directingSectorData = {
          id: this.directingSectorForm.id,
          name: this.directingSectorForm.name,
          notes: this.directingSectorForm.notes,
          professionals: this.directingSectorForm.professionals.map(professional => {
            return professional.value;
          }),
        };

        this.eventBus.$emit('IS_LOADING', true);
        if (this.directingSectorForm.id == null) {
          this.api.storeDirectingSector(directingSectorData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 201) {
              this.$swal('Uhull \\o/', 'A '+this.termSingular+' foi criada com sucesso!', 'success').then(() => {
                this.$router.push({path: '/' + this.url}).catch(() => {});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao criar a '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Directing Area', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos criar esta '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Directing Area', err.response);
          });
        } else {
          this.api.updateDirectingSector(this.directingSectorForm.id, directingSectorData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 200) {
              this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi atualizada com sucesso!', 'success').then(() => {
                this.$router.push({path: '/' + this.url}).catch(() => {});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Directing Area', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos atualizar esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Directing Area', err.response);
          });
        }
      },

      async deleteDirectingSector() {
        if(this.canRemove) {
          let doCancel = false;

          await this.$swal({
            title: 'Você tem certeza?',
            text: 'Esta ação não poderá ser desfeita!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              doCancel = true;
            }
          });
          if(doCancel) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
              this.api.deleteDirectingSector(this.directingSectorForm.id).then(res => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                if (res.status == 204) {
                  this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi excluída com sucesso!', 'success').then(() => {
                    this.$router.push({path: '/' + this.url}).catch(() => {});
                  });
                } else {
                  this.$swal('Ops...', 'Ocorreu um erro ao excluir a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
                }

                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Response Delete Directing Area', res);
              }).catch(err => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                this.$swal('Ops...', 'Não conseguimos excluir esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Error Delete Directing Area', err.response);
              });
          }
        }
      },

      goBack() {
        this.$router.push({path: '/' + this.url}).catch(() => {});
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .transaction-form {
    padding: 20px 0;


  }
</style>
